import { FC } from 'react'
import { useDispatch } from 'react-redux'
import { useQuery } from '@tanstack/react-query'

import Api from 'services/Api'
import { useDeleteUserSort } from 'Api'

import { closeModal } from 'store/actions/modals'
import { createErrorNotification } from 'store/actions/notifications'
import { refreshCounter } from 'store/actions/refresh'
import BaseModal from 'components/Modals/BaseModal'
import { Alert, Button } from 'ui'
import { Loading } from 'components/UI'

import { Trans } from 'react-i18next'
import { t } from 'translations'

type SortDeleteModalProps = {
  _id: string
}

const SortDeleteModal: FC<SortDeleteModalProps> = ({ _id }) => {
  const dispatch = useDispatch()
  const { mutate } = useDeleteUserSort()

  const { data, isLoading } = useQuery({
    queryKey: ['relatedProcedures', { _id }],
    queryFn: async () => await Api(`/users/sorts/dependencies`, { params: { _id } })
  })
  const relatedProcedures = data?.result || []

  const onDelete = () =>
    mutate(_id, {
      onSuccess: () => {
        dispatch(refreshCounter('filters'))
        dispatch(closeModal())
      },
      onError: () => dispatch(createErrorNotification())
    })

  if (isLoading) return <Loading />

  return (
    <BaseModal hideButtons title="administration.config.SORT.DELETE_BUTTON">
      <Alert variant="danger" className={'mt-2'}>
        {relatedProcedures?.length ? (
          <>
            <Trans t={t} i18nKey={'administration.config.SORT.DEPENDENCIES'}>
              <b></b>
              <ul>
                {relatedProcedures?.map(({ name, _id }) => {
                  return <li key={_id}>{name}</li>
                })}
              </ul>
            </Trans>
          </>
        ) : (
          <Trans t={t} i18nKey={'administration.confirmDeletion.WARNING'}>
            <b></b>
          </Trans>
        )}
      </Alert>

      <div className="mt-2">
        <Button className="mr-2" color="error" onClick={onDelete} disabled={!!relatedProcedures?.length}>
          {t('DELETE')}
        </Button>
        <Button color="secondary" outlined onClick={() => dispatch(closeModal())}>
          {t(`actions.CLOSE`)}
        </Button>
      </div>
    </BaseModal>
  )
}

export default SortDeleteModal
